import { injectable } from '@servicetitan/react-ioc';
import { CancelToken } from 'axios';

import { HttpClient } from './http-client';
import { BaseRequestModel } from '../models/base-request.model';
import { getBaseRequestParams } from '../utils/base-request-params';

@injectable()
export class EstimatesApi {
    constructor(private readonly httpClient: HttpClient) {}

    addEstimateItem = (
        estimateId: number,
        item: EstimateItemRequest,
        cancellationToken?: CancelToken
    ) => {
        return this.httpClient.post<EstimateItemResponse, EstimateItemRequest>(
            `/api/v1/estimates/${estimateId}/items`,
            item,
            {
                cancelToken: cancellationToken,
            }
        );
    };
}

export interface EstimateItemRequest {
    id: string;
    description?: string;
    unitCost?: number;
    unitPrice?: number;
}

export interface EstimateItemResponse {
    data?: any;
}
